import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { DEFAULT_LOCALE, localeFromPathname, shouldSkipLocalePrefix } from '../../util/locale';

/**
 * Client-side fallback for legacy unprefixed URLs (e.g. `/s` → `/en/s`).
 * Production SSR also 301s these; this covers CRA dev and in-app edge cases.
 */
const LegacyLocaleRedirect = () => {
  const location = useLocation();
  const { pathname, search, hash } = location;

  if (localeFromPathname(pathname) || shouldSkipLocalePrefix(pathname)) {
    return null;
  }

  const suffix = pathname === '/' ? '' : pathname;
  return <Redirect to={`/${DEFAULT_LOCALE}${suffix}${search}${hash}`} />;
};

export default LegacyLocaleRedirect;
